import { render, staticRenderFns } from "./VaccinneEdit.vue?vue&type=template&id=2bfefd39&"
import script from "./VaccinneEdit.vue?vue&type=script&lang=js&"
export * from "./VaccinneEdit.vue?vue&type=script&lang=js&"
import style0 from "./VaccinneEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports